import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/forum';

export default function ArticleCard({ article }: { article: Article }) {
  return (
    <article className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${article.id}`} className="block cursor-pointer">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={article.coverImage}
            alt={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            title={article.title}
          />
          <div className="absolute top-3 left-3 flex gap-2">
            {article.isHot && (
              <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500 text-background-50">
                热门
              </span>
            )}
            {article.isNew && (
              <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-accent-500 text-background-50">
                最新
              </span>
            )}
          </div>
        </div>
        <div className="p-5">
          <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors">
            {article.title}
          </h3>
          <p className="text-sm text-foreground-600 line-clamp-2 mb-4 leading-relaxed">
            {article.excerpt}
          </p>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-full overflow-hidden bg-background-200">
                <img src={article.avatar} alt={article.author} className="w-full h-full object-cover" />
              </div>
              <span className="text-xs text-foreground-500">{article.author}</span>
            </div>
            <div className="flex items-center gap-3 text-xs text-foreground-400">
              <span className="flex items-center gap-1">
                <i className="ri-eye-line"></i> {article.views > 1000 ? `${(article.views / 1000).toFixed(1)}k` : article.views}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-heart-line"></i> {article.likes}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-chat-3-line"></i> {article.comments}
              </span>
            </div>
          </div>
        </div>
      </Link>
    </article>
  );
}